import React from 'react';
import TestDashboard from '@/components/admin/tests/TestDashboard';

const AdminTestsPage = () => {
  return <TestDashboard />;
};

export default AdminTestsPage;
